import { createContext, useContext } from 'react';

export type IFeatureContext = {
    header?: {
        fadeUp?: boolean; // 是否淡入
    }
};

export const FeatureContext = createContext<IFeatureContext>({} as IFeatureContext);

export function useFeatureContext(): IFeatureContext {
    return useContext(FeatureContext);
}
